import * as React from 'react';

import LiteratureSubjectPage from '../../../containers/LiteratureSubjectPage';
import AssignmentFlowNavigation from '../assignment_flow_navigation';
import { getPageTitle } from '../../../../Shared';

const AssignLiteratureSubjectPage = () => {
  document.title = getPageTitle("Assign", "Literature")
  return (
    <div>
      <AssignmentFlowNavigation />
      <LiteratureSubjectPage />
    </div>
  )
}

export default AssignLiteratureSubjectPage
